import TabsWrapperProvider from "./TabsWrapperProvider";
import TabsWrapperContext from "./context";

export default TabsWrapperContext;
export { TabsWrapperProvider };
